export default function Cancel() {
  return (
    <div className="center-screen">
      <div className="glass-card">
        <h2>❌ Subscription Cancelled</h2>

        <p>No charges were made.</p>

        <a href="/app" className="primary-btn">
          Return to app
        </a>
      </div>
    </div>
  );
}
